import moment from "moment";
import "moment/locale/th";

export const simpleDate = (date: Date): string =>
  moment(date).format("DD/MM/YYYY");
export const simpleTime = (date: Date, showTimePeriod: boolean = true) =>
  moment(date).format(showTimePeriod ? "LT" : "HH:mm");
export const localeDate = (date: Date, locale: string): string => {
  return moment(date).locale(locale).format("ll");
};
export const fullTime = (date: Date) => moment(date).format("LTS");
